export const CUSTOMERS_SEARCH = 'CUSTOMERS_SEARCH';

export const CUSTOMERS_SEARCH_TERM_CHANGE = 'CUSTOMERS_SEARCH_TERM_CHANGE';
export const CUSTOMERS_SEARCH_CLEAR_INPUT = 'CUSTOMERS_SEARCH_CLEAR_INPUT';
export const CUSTOMERS_SET_SEARCH_PERFORMED = 'CUSTOMERS_SET_SEARCH_PERFORMED';

export const CUSTOMERS_GRID_REFRESH = 'CUSTOMERS_GRID_REFRESH';

export const customersGridRefresh = (setPageToOne = true) => ({
  type: CUSTOMERS_GRID_REFRESH,
  setPageToOne,
});

export const customersSearch = (searchData) => ({
  type: CUSTOMERS_SEARCH,
  searchData,
});

export const customerSearchTermChange = (searchValue) => ({
  type: CUSTOMERS_SEARCH_TERM_CHANGE,
  searchValue,
});

export const clearSearchInput = () => ({
  type: CUSTOMERS_SEARCH_CLEAR_INPUT,
});

export const setSearchPerformed = (searchPerformed) => ({
  type: CUSTOMERS_SET_SEARCH_PERFORMED,
  searchPerformed,
});
